<template>

  <div class="box">
    <div class="box-header with-border">
      <h3 class="box-title">Signaletics</h3>
    </div>

    <div class="box-body">

      <form class="form-horizontal">
        <div class="form-group">
          <label class="col-sm-2 control-label">Status</label>
          <div class="col-sm-8">
            <select @change="saveStatus($event)" class="form-control capitalize" :value="this.status">
              <option v-for="statusOption in this.statusOptions" :value="statusOption" class="capitalize"> {{statusOption.toLowerCase()}} </option>
            </select>
          </div>
        </div>
      </form>

      <hr/>

      <div>
        <form class="form-horizontal">
          <div class="form-group">
            <label class="col-sm-2 control-label">Tags</label>
            <div class="col-sm-10 new-tag-item">
              <multiselect 
                v-model="selectedTags"
                placeholder="Add new tag"
                track-by="name"
                :options="tagOptions"
                :multiple="true"
                :taggable="true"
                :custom-label="optionLabelFormatter"
                :closeOnSelect="false"
                :showLabels="false"
                @tag="tagNameConverter">
              </multiselect>
              <button type="button" class="btn btn-primary" v-on:click="saveTags" :disabled="!selectedTags.length">
                Add
              </button>
            </div>  
          </div>
        </form>

        <div class="tag-items">
          <template v-if="!associatedTags.length">      
            <p>No associated tags</p>
          </template>
          <template v-if="associatedTags.length">
            <span v-for="tag in associatedTags" class="tag-item" v-on:click="searchTag(tag.name)">
              <span class="label label-default">{{ tag.name }}</span>
              <i data-toggle="tooltip" data-placement="bottom" title="Remove tag" class="fa fa-close clickable"
                v-on:click.stop="removeTag(tag)"></i>
            </span>
          </template>
        </div>
      </div>

    </div>

  </div>

</template>

<script>
  import _ from 'lodash'
  import Multiselect from 'vue-multiselect'
  import api from '../../api'

  export default {
    name: 'Signaletics',
    props: ['id', 'type', 'status'],
    components: {Multiselect},
    data () {
      let options = []
      switch (this.type) {
        case 'testimonies':
          options = ['READ', 'UNREAD', 'PROCESSING', 'PROCESSED']
          break
        case 'cases':
          options = ['INITIATED', 'CLOSED', 'ANCHORED', 'DELETED']
          break
      }
      return {
        tagOptions: [],
        selectedTags: [],
        associatedTags: [],
        selectedStatus: this.status,
        statusOptions: options
      }
    },
    methods: {
      getTags () {
        api.authenticatedRequest('get', '/tags')
          .then(response => {
            this.tagOptions = _.differenceWith(response.data.data, this.associatedTags, (t1, t2) => t1.name === t2.name)
          })
          .catch(error => {
            console.log(error)
            if (error.response.status === 401) { // InvalidCredentialsError
              this.response = 'Username/Password incorrect. Please try again.'
              return
            }
            this.response = 'Server appears to be offline'
          })
      },
      getAssociatedTags () {
        api.authenticatedRequest('get', `/${this.type}/${this.id}/tags`)
          .then(response => {
            this.associatedTags = response.data
          })
          .catch(error => {
            console.log(error)
            if (error.response.status === 401) { // InvalidCredentialsError
              this.response = 'Username/Password incorrect. Please try again.'
              return
            }
            this.response = 'Server appears to be offline'
          })
          .finally(() => {
            this.getTags()
          })
      },
      saveTags () {
        const requests = this.selectedTags.map(tag => api.authenticatedRequest('post', '/tags', {
          name: tag.name,
          [this.type === 'cases' ? 'caseId' : 'testimonyId']: this.id
        }))

        Promise.all(requests)
          .catch(error => {
            console.log(error)
            if (error.response.status === 401) { // InvalidCredentialsError
              this.response = 'Username/Password incorrect. Please try again.'
              return
            }
            this.response = 'Server appears to be offline'
          })
          .finally(() => {
            this.getAssociatedTags()
            this.selectedTags = []
          })
      },
      saveStatus (event) {
        api.authenticatedRequest('put', `/${this.type}/${this.id}/status`, {
          status: event.target.value
        })
          .catch(error => {
            console.log(error)
            if (error.response.status === 401) { // InvalidCredentialsError
              this.response = 'Username/Password incorrect. Please try again.'
              return
            }
            this.response = 'Server appears to be offline'
          })
      },
      removeTag (tag) {
        api.authenticatedRequest('delete', `/tags/${tag.name}`, {
          [this.type === 'cases' ? 'caseId' : 'testimonyId']: this.id
        })
          .catch(error => {
            console.log(error)
            if (error.response.status === 401) { // InvalidCredentialsError
              this.response = 'Username/Password incorrect. Please try again.'
              return
            }
            this.response = 'Server appears to be offline'
          })
          .finally(() => {
            this.getAssociatedTags()
          })
      },
      searchTag (tagName) {
        let routeName = null
        switch (this.type) {
          case 'testimonies':
            routeName = 'Testimonies'
            break
          case 'cases':
            routeName = 'Cases'
            break
        }

        if (routeName) {
          this.$router.push({name: routeName, query: {tag: tagName}})
        }
      },
      optionLabelFormatter (option) {
        return `${option.name} (${option.count || '0'})`
      },
      tagNameConverter (name) {
        const tag = {name: name}
        this.tagOptions.push(tag)
        this.selectedTags.push(tag)
      }
    },
    mounted () {
      this.$nextTick(() => {
        this.getAssociatedTags()
      })
    }
  }
</script>

<style>
  .new-tag-item {
    display: flex;
  }

  .new-tag-item .btn {
    padding: 0 2em;
    margin-left: 1em;
  }

  .tag-items {
    margin-top: 10px;
    max-height: 90px;
    overflow: auto;
  }

  .tag-item {
    display: inline-flex;
    align-items: center;
    border: 1px solid #d0d6df;
    border-radius: 5px;
    margin: .25em;
    padding: 0;
    background-color: #d2d6de;
    font-size: 1.2em;
  }

  .tag-item .label {
    background-color: inherit;
    font-weight: normal;
    cursor: pointer;
  }

  .tag-item .fa-close {
    padding: 5px;
    font-size: 0.6em;
    transition: all .2s ease;
  }

  .tag-item .fa-close:hover {
    background-color: #e2e6ee;
  }

  /**
   Manually overriding components blocks height as not configurable by itself
   */
  .multiselect {
    min-height: 30px;
  }
  .multiselect > .multiselect__select {
    height: 30px;
  }
  .multiselect > .multiselect__tags {
    min-height: 30px;
    padding-top: 4px;
  }
  .multiselect > .multiselect__tags .multiselect__tag {
    margin-bottom: 0;
  }
  .capitalize {
    text-transform: capitalize;
  }
</style>



// WEBPACK FOOTER //
// Signaletics.vue?4b9bd74f